import { render, staticRenderFns } from "./cross-slip-wrapper.vue?vue&type=template&id=0ce150e5&scoped=true&"
import script from "./cross-slip-wrapper.vue?vue&type=script&lang=js&"
export * from "./cross-slip-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./cross-slip-wrapper.vue?vue&type=style&index=0&id=0ce150e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce150e5",
  null
  
)

export default component.exports